module.exports = __webpack_public_path__ + "img/7.0a91a4d9.png";